/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_MeasurementInputs */

const en_us2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measurement`)
};

const pt_br2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida registrada`)
};

const es_419_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida registrada`)
};

const pt_pt2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medida registada`)
};

const fr_fr2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuration`)
};

const de_de2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messung`)
};

const it_it2_offline_kind_measurement = /** @type {(inputs: Offline_Kind_MeasurementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura`)
};

/**
* | output |
* | --- |
* | "Measurement" |
*
* @param {Offline_Kind_MeasurementInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_measurement = /** @type {((inputs?: Offline_Kind_MeasurementInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_MeasurementInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_measurement(inputs)
	if (locale === "es-419") return es_419_offline_kind_measurement(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_measurement(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_measurement(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_measurement(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_measurement(inputs)
	return en_us2_offline_kind_measurement(inputs)
});
export { offline_kind_measurement as "offline.kind_measurement" }